import { render, staticRenderFns } from "./GPie.vue?vue&type=template&id=0ebccc11"
import script from "./GPie.vue?vue&type=script&lang=js"
export * from "./GPie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports